import { render, staticRenderFns } from "./BusinessPartner.vue?vue&type=template&id=4d8b6f8f&"
import script from "./BusinessPartner.vue?vue&type=script&lang=js&"
export * from "./BusinessPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports